import { Wrapper, BalanceWrapper, ShortcutWrapper, ShortcutButton, Balance, CopyButton } from './styled'
import RefreshButton from '../RefreshButton'
import { formatAmount } from 'utils/amountFormat'
import { useCallback } from 'react'
// import { useAlert } from 'react-alert'
import { useToastAlert } from 'hooks/useToastAlert'
import themeAsseticonCopyPng from '@theme/icon/copy.png'
import themeAsseticonRefreshSvg from '@theme/icon/refresh.svg'
import themeAssetgameIconSavePng from '@theme/game/icon-save.png'
import themeAssetgameIconWithdrawPng from '@theme/game/icon-withdraw.png'
import themeAssetgameIconBonusPng from '@theme/game/icon-bonus.png'
import themeAssetgameIconServicePng from '@theme/game/icon-service.png'

interface BalanceBarProps {
  uid?: string | number
  balance?: number
  onRefresh?: () => void
  toGameDeposit?: () => void
  toGameWithdraw?: () => void
  toGamePromotion?: () => void
  toService?: () => void
}

export default function BalanceBar({
  uid,
  balance,
  onRefresh,
  toGameDeposit,
  toGameWithdraw,
  toGamePromotion,
  toService,
}: BalanceBarProps) {
  // const uidRef = useRef(null)
  const { toast } = useToastAlert()

  const handleCopyUid = useCallback(async () => {
    if (uid && navigator.clipboard) {
      await navigator.clipboard.writeText(String(uid))
      toast('已复制ID至剪贴簿')
    }
  }, [toast, uid])

  return (
    <Wrapper>
      <BalanceWrapper>
        <div>
          ID:{uid}
          <CopyButton onClick={handleCopyUid}>
            <img src={themeAsseticonCopyPng} alt="复制"></img>
          </CopyButton>
          {/* <UidBox defaultValue={uid} ref={uidRef}></UidBox> */}
        </div>
        <Balance>
          <span>￥{formatAmount(balance ?? 0)}</span>
          <RefreshButton img={themeAsseticonRefreshSvg} onClick={onRefresh}></RefreshButton>
        </Balance>
      </BalanceWrapper>
      <ShortcutWrapper>
        <ShortcutButton
          onClick={toGameDeposit}
          data-testid="game_deposit_btn"
          aria-label="game_deposit_btn"
        >
          <img src={themeAssetgameIconSavePng} alt="存款"></img>
          <span>存款</span>
        </ShortcutButton>
        <ShortcutButton onClick={toGameWithdraw}>
          <img src={themeAssetgameIconWithdrawPng} alt="取款"></img>
          <span>取款</span>
        </ShortcutButton>
        <ShortcutButton onClick={toGamePromotion}>
          <img src={themeAssetgameIconBonusPng} alt="优惠"></img>
          <span>优惠</span>
        </ShortcutButton>
        <ShortcutButton onClick={toService}>
          <img src={themeAssetgameIconServicePng} alt="客服"></img>
          <span>客服</span>
        </ShortcutButton>
      </ShortcutWrapper>
    </Wrapper>
  )
}
